import { render, staticRenderFns } from "./Top_Selling_Item.vue?vue&type=template&id=cc9609ce&scoped=true&"
import script from "./Top_Selling_Item.vue?vue&type=script&lang=js&"
export * from "./Top_Selling_Item.vue?vue&type=script&lang=js&"
import style0 from "./Top_Selling_Item.vue?vue&type=style&index=0&id=cc9609ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9609ce",
  null
  
)

export default component.exports